import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from './../services/msal.service';

@Injectable()
export class MsalGuard implements CanActivate {

    constructor(private router: Router, private msalService: MsalService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.msalService.authenticated) {
            return true;
        } else {
            console.info("Not authenticated, redirecting to login page");
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(childRoute, state);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/_shared/guards/msal.guard.ts